import React from 'react';
import {
	useEffect,
	useState,
} from 'react';

import {
	Container,
	TabPane,
	TabContent,
} from "reactstrap";

import '../../stylesheets/nutrition.scss';

import {Bottom} from "../parts/MyTree/Bottom";
import {Equivalents} from "../parts/Equivalents";
import * as Parts from "../parts/NutritionLabelParts";

import {Benefits} from "../../classes/benefits";
import {Project} from "../../classes/project";

import {TABS} from "../../utilities/resources";


const ACTIVE_TAB_CLASSES = "active border border-primary";
const SUB_TABS = [
	"Benefits",
	"Equivalents",
];


export const TotalBenefits = (
	{
		currency,
		history,
		location,
		projects,
		unitType,
	}
) => {
	let [activeTab, setActiveTab] = useState(1);
	let [activeSubTab, setActiveSubTab] = useState(0);
	let namesAndAddresses = [];
	let benefitsToDisplay;
	let totalBenefits = new Benefits();
	let proximity = false;
	let date = 0;
	let mostRecentProject = new Project();

	useEffect(
		() => {
			if (projects) {
				let searchParams = `?era=${activeTab === 0 ? "current" : "forecast"}&type=${activeSubTab === 0 ? "benefits" : "equivalents"}&uuid=all`;
				history.push(
					`${location.pathname}${searchParams}`
				);
			}
		},
		[
			activeSubTab,
			activeTab,
			projects,
			history,
			location.pathname,
		]
	);

	projects.forEach((project) => {
		let {building, creationDate, tree} = project;
		namesAndAddresses.push(
			{
				key: `${project.uuid}-name-and-address`,
				name: <span>{tree.name ? `${tree.name}, ` : null}{tree.common}, <em>({tree.scientific})</em></span>,
				address: project.location.getAbbreviatedLocation(),
			}
		);
		// Determines if any trees have a proximate building.
		// If true, the energy benefits will be shown.
		if (!proximity && building.proximity === 0) proximity = 0;

		if (creationDate >= date) {
			mostRecentProject = project;
			date = creationDate;
		}

		let {benefits, futureBenefits} = {...project};

		if (activeTab === 0) {
			benefitsToDisplay = {...benefits};
		} else {
			benefitsToDisplay = {...futureBenefits};
		}

		for (let field in benefitsToDisplay.__fields()) {
			if (
				typeof benefitsToDisplay[field] === "object" &&
				benefitsToDisplay[field] instanceof Object
			) {
				if (benefitsToDisplay[field].__fields) {
					for (let item in benefitsToDisplay[field].__fields()) {
						if (
							field === "energy" ||
							(
								field !== "hydro" &&
								item.toLowerCase().includes("avoided")
							)
						) {
							if (building.proximity === 0) {
								totalBenefits[field][item] += parseFloat(benefitsToDisplay[field][item]);
							}
						} else {
							totalBenefits[field][item] += parseFloat(benefitsToDisplay[field][item]);
						}
					}
				}
			} else {
				if (typeof benefitsToDisplay[field] === "number") {
					totalBenefits[field] = totalBenefits[field] += benefitsToDisplay[field];
				}
			}
		}
	});

	const toggle = (tab) => {
		setActiveTab(tab);
	};

	const toggleSubTab = (tab) => {
		setActiveSubTab(tab);
	};

	return (
		<React.Fragment>
			<Parts.Controls
				toggleFunction={toggle}
				id={"benefits-year-toggle"}
				selected={activeTab}
				settings={TABS}
			/>
			<Parts.TabToggle
				function={toggleSubTab}
				selected={activeSubTab}
				tabs={SUB_TABS}
				activeTabClasses={ACTIVE_TAB_CLASSES}
			/>
			{benefitsToDisplay ?
				<TabContent
					activeTab={activeSubTab}
					className={"nutrition"}
				>
					<TabPane tabId={0}>
						<Container>
							<Parts.Header/>
							<ul className={"list-unstyled"}>
								{
									namesAndAddresses.length ? namesAndAddresses.map(
										(nAndA) => {
											return (
												<li key={nAndA.key}>
													{nAndA.name}<br/><span className={"ms-2"}>{nAndA.address}</span>
												</li>
											);
										}
									)
									: null
								}
							</ul>
							<Parts.ServingSize
								total={true}
								count={projects.length}
							/>
							<Parts.Annual
								tab={activeTab}
								location={mostRecentProject.location}
								currency={currency}
								value={totalBenefits.totalDollarValue()}
							/>
							<Parts.BenefitsTable
								tab={activeTab}
								unitType={unitType}
								benefits={totalBenefits}
								proximity={proximity}
								currency={currency}
							/>
						</Container>
					</TabPane>
					<TabPane tabId={1}>
						<Equivalents
							common={"Tree Collection Totals"}
							activeTab={activeTab}
							benefits={totalBenefits}
							locationForDisplay={null}
							unitType={unitType}
						>
							{{
								intro: <p>With care and
									maintenance,<br/> after {activeTab === 0 ? "1 year" : "20 years"} these
									trees<br/>could potentially:</p>,
								label: <div>
									<p className={"h3 fw-bold"}>
										MyTrees
									</p>
									<p className={"mt-n2 h5 fw-bold"}>
										Work hard for me!
									</p>
								</div>
							}}
						</Equivalents>
					</TabPane>
					<Bottom
						activeTab={activeTab}
						activeSubTab={activeSubTab}
						dbVersion={benefitsToDisplay.meta.dbVersion}
						engineVersion={benefitsToDisplay.meta.engineVersion}
					/>
				</TabContent>
				:
				null
			}
		</React.Fragment>
	);
};
